import { AppDomainConfig } from "../../envConfig";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["io"],
  font: "16px arial",
  iconCategories,
  id: "RVF",
  name: "RVF",
  pictures: [
    { id: "rvf_naturenergie_sharing_logo.png" },
    { id: "rvf_grueneflotte_logo.png" },
    { id: "rvf_frelo_logo.png" },
  ],
  settings: {
    stops_api_prefagencies: "db,sbb",
  },
  slug: "rvf",
  ...colors,
};

export default config;
